<template>
  <div class="flex flex-col justify-between">
    <div
      v-for="(value, key) in values"
      :key="key"
      class="flex flex-col flex-1 mb-4 group"
    >
      <div
        class="flex justify-between w-full mb-1 text-grey"
        :class="`group-hover:text-${color(value)}`"
      >
        <div class="flex items-center text-sm font-medium">
          <svg
            class="h-4 mr-1 fill-current"
            :class="`text-${color(value)}`"
            viewBox="0 0 12 16"
            xmlns="http://www.w3.org/2000/svg"
            v-if="value < 1978"
          >
            <path
              d="M.4773 10.1367c.1625-.1074.325-.2146.5084-.336-.318-.219-.6118-.4216-.9055-.624.0382-.0204.0764-.0409.1146-.0616-.0405-.232-.081-.4641-.1217-.6962-.0236-.1346-.106-.3475-.0587-.3876.1005-.085.2785-.13.4072-.1016.3063.0674.6027.1871.9766.3098-.237-.3694-.4312-.6726-.6585-1.0272l.4111-.1055c-.0126-.0385-.0136-.088-.0353-.1022-.4932-.322-.1105-.7687-.131-1.1547-.0013-.0224.2532-.1033.3761-.0803.221.041.3861.3718.6823.125.026-.0217.2929.2815.4757.461.1907-.3955.372-.2135.5193.0554.5245.9583 1.0397 1.9224 1.5835 2.9306.3487-1.9781-.5864-3.7266-.8888-5.7078.3288.1307.5303.211.7515.299-.067-.296-.1308-.579-.2119-.9384.2003.0596.3187.095.4586.1365.0498-.2373.099-.4732.1623-.7768.6488.3387.645 1.0082.89 1.6167.0856-.6244.151-1.159.236-1.6903.0308-.1923.0834-.3915.1731-.559.0662-.1235.1999-.2575.3207-.2796.0799-.0147.2078.1477.2828.2553.076.1092.1133.2485.2033.4582.0778-.3553.122-.6268.1984-.888.1026-.3496.2594-.5851.4875-.27C8.1003.6538 8.4951.3269 8.8898 0c.0564.022.1129.044.1691.0661.0441.4093.0884.8188.1355 1.2593.0693.0105.1922.0295.4079.0624-.2515.4502-.4684.8388-.7241 1.2963.3097-.0848.5437-.1487.8352-.2284-.084 1.0238-.728 1.6079-1.254 2.2639l1.345-.9103.1166.1315c-.0732.325-.146.6498-.2192.975l.1062.0494c-.1684.1473-.3367.2946-.5512.4817.428.1623.263.3699.0483.5389-.3526.2775-.7198.535-1.086.7927-1.0018.7051-1.4194 1.7558-1.65 3.0814 1.2015-.8046 1.7607-1.9405 2.1716-3.2726.1738.2237.2754.3544.3918.5045l.7722-1.568.3353.2762.9658-1.0793c.0683.0204.1367.0413.205.062.0394.4411.0788.882.1216 1.363.0843.0067.2084.0166.4676.0375-.2933.4622-.5384.849-.7832 1.2347.017.0076.0439.0287.0719.0306.2033.0136.4072.0235.6108.0345-.083.2232-.112.5048-.2596.6577-.3358.348-.7274.636-1.1015.9413-.1442.1175-.3024.216-.4267.3869.2707-.06.5394-.1393.8132-.1712.1136-.0133.2728.0418.3445.1281.0455.055-.0095.2364-.058.3406-.3444.7379-.8489 1.2281-1.6617 1.365-.7999.1344-1.5934.3357-2.375.5637-1.7344.5062-2.2873 1.4414-1.8892 3.6134.0862.4695-.046.6172-.5522.6915 0-.7527-.0894-1.4765.0177-2.166.2608-1.681-.9455-2.567-2.082-2.9926-.5045-.1888-1.061-.2187-1.5903-.338-.2055-.0463-.4015-.1393-.602-.2112l.0006-.1555"
              fill-rule="evenodd"
            />
          </svg>
          <span>{{ key }}</span>
        </div>
        <div>
          <span class="font-bold "> {{ value }} </span>
          <span
            class="text-xs  text-taupe-dark"
            :class="`group-hover:text-${color(value)}`"
            >kg / h</span
          >
        </div>
      </div>

      <div class="flex-1">
        <progress-bar
          :value="value"
          :max="max"
          :color="color(value)"
          class="h-2 "
        />
      </div>
    </div>
    <div class="items-center h-5 pb-6 xl:pb-0 xl:flex">
      <div
        class="flex justify-around flex-1"
        style="margin-left:-5%; margin-right: -6%;"
      >
        <div
          v-for="i in (0, 10)"
          :key="i"
          class="flex flex-col items-center flex-1 text-center text-2xs text-grey"
        >
          <div class="w-px h-2 mb-1 bg-gray-600 bg-grey"></div>
          <span>{{ (i - 1) * 1000 }}</span>
        </div>
      </div>
    </div>

    <!-- <div class="flex bg-green">
                <div class="hidden w-1/4 mr-8 text-sm text-gray-600 bg-blue-400  xl:block">
                    {{ key }}
                </div>
                <div class="flex items-center justify-between flex-1 h-8 bg-red-500">

                </div>
            </div> -->
  </div>
</template>
<script>
import ProgressBar from "./ProgressBar";
export default {
  components: { ProgressBar },

  data: () => ({
    max: 9000,
    values: {
      "Pilatus PC-12": 670,
      //  "King Air 350": 1193,
      // "Cessna Citation CJ3": 1700,
      "Pilatus PC-24": 1994,
      "Embraer Phenom 300": 2198,
      // "Gulfstream G200": 2590,
      // "Learjet 70/75": 2850,
      // "Hawker 900XP": 3065,
      "Cessna Citation Latitude": 2855,
      "Bombardier Challenger CL 350": 3931,
      // "Dassault Falcon 7X": 3793,
      //"Cessna Citation X+": 4007,
      "Bombardier Global 6000": 6105,
      //  "Airbus ACJ319": 7632,
      "Gulfstream G650": 8874,
      // "Gulfstream G650": 8000
    },
  }),
  computed: {
    style() {
      return {
        width: `${this.value}%`,
      };
    },
  },
  methods: {
    color(value) {
      if (value < this.max * 0.2) {
        return "green";
      } else if (value > this.max * 0.3 && value < (this.max / 3) * 2) {
        return "glade";
      } else if (value > this.max * 0.3) {
        return "orange";
      }
      return "green-dark";
    },
  },
};
</script>
